import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StaticConstantsService {
  public static auth: string;

  public static buildType = "BROWSER";

  public roleList: string[] = ["Demand Head", "Regional Head", "Floor Manager",
    "Demand Executive - Registration & Completion", "Demand Executive - Start Bidding", "Demand Executive - Payment Collection"];
  public permissionList: string[] = ["Start Bidding", "Payment Collection", "Registration", "Completion"];
  public fseStatusList: string[] = ["Validated", "Not Validated"];
  public completionStatusList: string[] = ["Never Bidded", "Lost"];
  public participationStatusList: string[] = ["Completed", "In Complete", "Active", "In Active"];
  public participationStatusListFilter: string[] = ["Completed", "In Complete", "Active", "In Active (Never Bidded)", "In Active (Prior Bidded)", "Blocked"];
  public portalStatusList: string[] = ["Blocked", "UnBlocked"];
  public buyerStatus: string[] = ["Pending", "Confirmed", "Rejected"];
  // public paymentStatus: string[] = ["Full", "Partial", "Rejected"];
  public paymentStatus: string[] = ["Full", "Partial"];
  public proofOfDocumentList: string[] = ["GST Certificate", "Company PAN", "Certificate of InCooperation", "Participation Deed", "Any Trade License With State or Central Govt"]

  public locationPreferenceList: string[] = ["Delhi", "Mumbai", "Chennai", "Kolkata", "Bangalore", "Pune", "Hyderabad", "Jaipur", "Ahmadabad", "Chandigarh"];
  public gradePreferenceList: string[] = ["Brand New", "Open Box", "Very Good", "Good", "Acceptable", "Defective", "Not Tested", "Mixed", "Refurbished Acceptable", "Refurbished Good", "Refurbished Very Good", "New"];
  public primaryCategoryList: string[] = ["Electronics and Appliances", "Fashion and Style", "IT", "Others"];



  public dummyNameList: string[] = ["Ram", "Shyam", "Mohan", "Akshay", "Vijay", "Lilly", "Ruby", "Monica", "Tina", "Riya"];
  public dummySurNameList: string[] = ["Sharma", "Verma", "Panday", "Boss", "Khanna", "Singh", "Kapur", "Das", "Soni", "Yadav"];
  public dummyAreaList: string[] = ["Society", "Vihar", "Colony", "Road"];
  public dummyAreaNameList: string[] = ["Sastri", "Vidhyadhar", "Enclave", "Diamond"];
  public dummyCompanyList: string[] = ["Kapoor", "Agarwal", "Larson", "Gibbson"];
  public dummyCompany2List: string[] = [" & Sons", " IT Solutions", " Brothers", " Venture"];
  public secondaryCategoryList: string[] = [];


  public userStatus: string[] = ["Enable", "Disable"];

  createSecondaryCategoryList(primaryCategoryList: string[]) {
    this.secondaryCategoryList = [];
    if (primaryCategoryList.indexOf('Electronics') > -1) {
      this.secondaryCategoryList.push('TV');
      this.secondaryCategoryList.push('Fridge');
      this.secondaryCategoryList.push('AC');
      this.secondaryCategoryList.push('Microwave');
      this.secondaryCategoryList.push('Food Processor');
      this.secondaryCategoryList.push('Washing Machine');
    }
    if (primaryCategoryList.indexOf('Fashion') > -1) {
      this.secondaryCategoryList.push('Men Apparels');
      this.secondaryCategoryList.push('Women Apparels');
      this.secondaryCategoryList.push('Kids Apparels');
      this.secondaryCategoryList.push('Cosmetic');
      this.secondaryCategoryList.push('Jewellers');
    }
    if (primaryCategoryList.indexOf('IT') > -1) {
      this.secondaryCategoryList.push('Mobile');
      this.secondaryCategoryList.push('Tablet');
      this.secondaryCategoryList.push('Mobile Accessories');
      this.secondaryCategoryList.push('Laptop');
      this.secondaryCategoryList.push('Computer Accessories');
      this.secondaryCategoryList.push('Camera');
    }
    if (primaryCategoryList.indexOf('OTHER') > -1) {
      this.secondaryCategoryList.push('Fan');
      this.secondaryCategoryList.push('Mixer');
      this.secondaryCategoryList.push('Furniture');
      this.secondaryCategoryList.push('Plastics');
      this.secondaryCategoryList.push('Other');
    }
  }
}

